(function () {
  function getHandlesFromGrid(grid) {
    var handles = [];
    var handleAttr = (grid.dataset.linkHandle || '').toLowerCase().trim();
    if (handleAttr) handles.push(handleAttr);
    var url = grid.dataset.linkUrl || '';
    var cleanUrl = url.split('?')[0].split('#')[0];
    var parts = cleanUrl.split('/').filter(Boolean);
    var last = parts[parts.length - 1];
    if (last) handles.push(last.toLowerCase());
    return handles;
  }

  function inject() {
    var portals = document.querySelectorAll('.mega-menu-v2-portal');
    if (!portals.length) return;

    portals.forEach(function (portal) {
      var target = (portal.dataset.megaMenuV2Target || '').toLowerCase().trim();
      if (!target) return;

      // Source : reste dans le portail, on clone pour permettre re-injection
      var source = portal.querySelector(':scope > .mega-menu-v2__custom');
      if (!source) return;

      var grids = document.querySelectorAll('.mega-menu__grid[data-link-url]');
      grids.forEach(function (grid) {
        // Déjà injecté dans cette grid : skip
        if (grid.querySelector(':scope > .mega-menu-v2__custom')) return;
        var handles = getHandlesFromGrid(grid);
        if (handles.indexOf(target) === -1) return;

        var clone = source.cloneNode(true);
        grid.appendChild(clone);
        grid.classList.add('mega-menu__grid--has-v2');
      });
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  window.addEventListener('load', inject);
  document.addEventListener('shopify:section:load', inject);
  document.addEventListener('shopify:block:load', inject);

  // MutationObserver pour gérer les ré-renders du menu (sticky, overflow-list, AJAX nav, etc.)
  var pendingInject = null;
  function scheduleInject() {
    if (pendingInject) return;
    pendingInject = requestAnimationFrame(function () {
      pendingInject = null;
      inject();
    });
  }
  var observer = new MutationObserver(scheduleInject);
  observer.observe(document.body, { childList: true, subtree: true });
})();
